import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';
import { debuglog } from 'util';

class CreateGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            prefixError: '',
            rangeFromError: '',
            rangeToError: '',
            slotError: '',
            AvailableGroupError: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            prefixData: [],
            availableGroup: '',
            loader: true,
            otherPrependPrefix: '',
            btnLoader: false
        };
    }
    flipInput = (e) => {
        $('.select-list').toggle();
        $('.change-select-text').text(e.target.getAttribute('currentoption'));
        let currentOption = e.target.getAttribute('currentoption');
        let currentPrefix = '';
        if (currentOption == 'Other') {
            $('input[name="prefix"]').prop("disabled", false);
            this.setState({ availableGroup: '' });
            $('.save').attr("disabled", true);
        } else {
            $('input[name="prefix"]').prop("disabled", true);
            $('input[name="prefix"]').val('');
            currentPrefix = currentOption;

            // set available group as per prefix
            this.availablePrefix(currentPrefix);
        }
    }
    componentDidMount() {
        this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, this.props.wholesalerId);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        $('.save').attr("disabled", true);
    }
    availablePrefix = (currentPrefix) => {
        $('.save').attr("disabled", false);
        try {
            var MatchedAvail = '';
            if (this.state.prefixData != null && this.state.prefixData.length > 0) {
                MatchedAvail = this.state.prefixData[0].gnlist.filter((option) => {
                    if (option.prefix != "")
                        return option.prefix.toUpperCase() == currentPrefix.toUpperCase();
                });
            }
            if (MatchedAvail == '')
                this.setState({ availableGroup: currentPrefix + '100', prefixError: '', loader: false })
            else
                this.setState({ availableGroup: MatchedAvail[0].gn, prefixError: '', loader: false })
        }
        catch (error) {
        }
    }
    fetchDataLocally(roleName, roleType, id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, id })
            };
            return fetch(`/api/admin/GroupPrefix`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ prefixData: apidata });
                        const firstPrefix = this.state.prefixData.map((e1) => {
                            return e1.prefix[0]
                        });
                        this.availablePrefix(firstPrefix[0]);
                        $('.save').attr("disabled", false);
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleValidate = (e) => {
        $(e.target).attr("disabled", true);
        $('.cancelPop').attr("disabled", true);
        $('.cancel').attr("disabled", true);

        this.setState({ loader: true, btnLoader: true });

        try {
            e.preventDefault();
            let IsErrorExists = true;

            // variable declaration
            let prefix;

            // assign values to variables
            let selectedPrefix = $('#prefix .change-select-text').text();
            let allprefixes = this.state.prefixData;
            let groupList = allprefixes[0].gnlist;
            let whId = this.props.wholesalerId;
            let whName = this.props.whName;
            let midGroupNumber = $('input[name="midGroup"]').val();
            let pattern = /^[A-Za-z]+$/;

            if (selectedPrefix == 'Other') {
                let inputPrefix = $('input[name="prefix"]').val();

                if (userService.Check_Null_Empty(inputPrefix)) {
                    this.setState({ prefixError: 'Custom Prefix cannot be blank', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                } else if (!pattern.test(inputPrefix)) {
                    this.setState({ prefixError: 'Custom prefix must be alphabet only', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                } else if (inputPrefix.length == 1) {
                    this.setState({ prefixError: 'Custom Prefix must be at least 2 characters', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                } else if (inputPrefix.length > 6) {
                    this.setState({ prefixError: 'Custom Prefix can only be 6 characters long', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                } else {
                    groupList.forEach((item) => {

                        if ((item.prefix.toUpperCase()) == (inputPrefix.toUpperCase())) {
                            this.setState({ prefixError: 'This Custom Prefix is already in use', loader: false, btnLoader: false });
                            $(e.target).attr("disabled", false);
                            $('.cancelPop').attr("disabled", false);
                            $('.cancel').attr("disabled", false);
                            IsErrorExists = false;
                        } else {
                            prefix = inputPrefix;
                        }
                    });
                }
            } else {
                prefix = selectedPrefix;
            }

            // set prefix in uppercase
            let changePrefixCase = prefix.toUpperCase();

            // mid group check
            if (midGroupNumber == "") {
                this.setState({ AvailableGroupError: 'Group number count cannot be blank', loader: false, btnLoader: false });
                $(e.target).attr("disabled", false);
                $('.cancelPop').attr("disabled", false);
                $('.cancel').attr("disabled", false);
                IsErrorExists = false;
            } else {
                if (midGroupNumber == 0 || midGroupNumber < 0) {
                    this.setState({ AvailableGroupError: 'Group number count is invalid', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    IsErrorExists = false;
                }
                else if (this.CheckIsDecimal(midGroupNumber)) {
                    this.setState({ AvailableGroupError: 'Group number count must be integer only', loader: false, btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancelPop').attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    IsErrorExists = false;
                }
            }

            if (IsErrorExists == true) {
                this.createGroupNumber(changePrefixCase, whName, whId, midGroupNumber);
            }
        }
        catch (error) {
        }

    }
    createGroupNumber(preFix, whName, whId, Count) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ preFix, whName, whId, Count })
            };
            return fetch(`/api/admin/AddGroupNumberForWh`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata[0].code == "1") {
                            this.setState({
                                error: apidata[0].statusMessage,
                                loader: false,
                                btnLoader: false
                            });
                            setTimeout(() => {
                                this.cancelPopup();
                            }, 2000);
                        } else {
                            this.setState({ error: apidata[0].statusMessage, loader: false, btnLoader: false });
                            $('.save').attr("disabled", false);
                            $('.cancel').attr("disabled", false);
                            $('.cancelPop').attr("disabled", false);
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false, btnLoader: false });
                        $('.save').attr("disabled", false);
                        $('.cancel').attr("disabled", false);
                        $('.cancelPop').attr("disabled", false);
                    }
                });
        }
        catch (error) {
        }
    }
    otherPrefix = () => {
        let currentPrefix = $('input[name="prefix"]').val();
        if (currentPrefix == '' || currentPrefix == undefined || currentPrefix == null) {
            this.setState({ availableGroup: '', loader: false, prefixError: '' });
            $('.save').attr("disabled", true);
        } else if (currentPrefix.length == 1) {
            this.setState({ availableGroup: '', loader: false });
            $('.save').attr("disabled", false);
        } else if (currentPrefix.length > 6) {
            this.setState({ availableGroup: '', loader: false });
            $('.save').attr("disabled", false);
        }
        else
            this.availablePrefix(currentPrefix);
    }
    cancelPopup = () => {
        this.props.closeCreateGroupPopup(this.props.wholesalerId, this.props.whName, this.props.activeWhPagin, this.props.activePagin, this.props.whRule, this.props.whSearch);
        this.props.openManageGroupPopup(this.props.wholesalerId, this.props.whName, this.props.activeWhPagin, this.props.activePagin, this.props.whRule, this.props.whSearch);
    }
    handleSelect = () => {
        $('.select-list').toggle();
    }
    closeSelect = () => {
        $('.select-list').hide();
    }
    handleGroup = () => {
        this.setState({ AvailableGroupError: '' });
    }
    CheckIsDecimal(n) {
        var result = (n - Math.floor(n)) !== 0;

        if (result)
            return true;
        else
            return false;
    }
    render() {
        const { prefixError, AvailableGroupError, error } = this.state;

        return (
            <div className="manage-scroll manage-distributor-design">
                <div className='popup mfp-zoom-in report-section create-group'>
                    <div className='popup_inner'>
                        <h1>{this.props.titleText}<button className="cancelPop" onClick={this.cancelPopup}>X</button></h1>
                        <form>
                            <div className="formgroup">
                                <label>Select Prefix</label>
                                <span className="down-arrow"></span>
                                {
                                    this.state.prefixData.map((e1, index) => {
                                        return (
                                            <div onMouseLeave={this.closeSelect} key={index}>
                                                <span className="form-control select" id="prefix" onClick={this.handleSelect}>
                                                    <span className="change-select-text">{e1.prefix[0]}</span>
                                                </span>
                                                <div className="select-list">
                                                    {
                                                        e1.prefix.map((option, index) => {
                                                            return (
                                                                <div onClick={this.flipInput} currentoption={option} key={index}>{option}</div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <span className="or">OR</span>
                            <div className="formgroup">
                                <label>Create New Prefix</label>
                                <input name="prefix" className="form-control" onKeyUp={this.otherPrefix} disabled type="text" />
                                {prefixError &&
                                    <div className={'alert-error'}>{prefixError}</div>
                                }
                            </div>
                            <div className="formgroup">
                                <label>Available Group Number from</label>
                                <span> <b>{this.state.availableGroup}</b></span>
                            </div>
                            {/*
                            <div className="formgroup">
                                <div className="left">
                                    <label>Group Number Range from</label>
                                    <input type="number" name="rangeFrom" className="form-control" defaultValue="9501" />
                                    {rangeFromError &&
                                        <div className={'alert-error'}>{rangeFromError}</div>
                                    }
                                </div>
                                <div className="right">
                                    <label>Group Number Range To</label>
                                    <input type="number" name="rangeTo" defaultValue="10499" className="form-control" />
                                    {rangeToError &&
                                        <div className={'alert-error'}>{rangeToError}</div>
                                    }
                                </div>
                            </div>
                            <div className="formgroup">
                                <input type="checkbox" className="form-control checkbox" name="slot" /> <span className="slot">Availabel slots</span>
                                {slotError &&
                                    <div className={'alert-error'}>{slotError}</div>
                                }
                            </div>
                            */}
                            <div className="formgroup">
                                <label>Number of Group Numbers</label>
                                <input type="number" name="midGroup" defaultValue="1" className="form-control" onChange={this.handleGroup} />
                                {AvailableGroupError &&
                                    <div className={'alert-error'}>{AvailableGroupError}</div>
                                }
                            </div>
                            <div className="formgroup last-one">
                                {
                                    this.state.loader ? (<div className={this.state.btnLoader ? 'theme-loader group-loader animated-loader' : 'theme-loader group-loader'}></div>) : null
                                }
                                <input className={this.state.btnLoader ? 'btn save animated-btn' : 'btn save'} onClick={this.handleValidate} type="submit" value="Save & Create" />
                                <input className="btn cancel" type="button" value="Cancel" onClick={this.cancelPopup} />
                            </div>
                            {error &&
                                <div className={'alert alert-danger group-error'}>{error}</div>
                            }
                        </form>

                    </div>
                </div>
            </div>
        )
    }
}

export default CreateGroup;